import { useState } from "react";
import DealInquiryModal from "../../components/DealInquiryModal";

const VECTORS = [
  {
    key: "shareholder", n: "01", title: "If you hold shares", testid: "access-vector-shareholders",
    body: "We buy part of a position, not all of it. We read the stock purchase agreement before any price is discussed, and we obtain written confirmation from the company or its transfer agent that a transfer would be recognized on its books. We will not proceed without it.",
  },
  {
    key: "broker", n: "02", title: "If you are a broker or a platform", testid: "access-vector-brokers",
    body: "Our buyers are verified and their documents are signed before a deal exists, so the clock starts at allocation and not at onboarding. Bring us the position and we respond directly.",
  },
  {
    key: "fund", n: "03", title: "If you are a fund selling down a position", testid: "access-vector-allocators",
    body: "We buy a direct position in a named portfolio company. We do not buy LP interests and we are not running a fund secondaries strategy.",
  },
];

export default function AccessVectors() {
  const [active, setActive] = useState(null);
  return (
    <section className="hairline py-16 rise" data-testid="access-vectors">
      <span className="t-label">Who we transact with</span>
      <p className="t-small text-muted-s mt-3 measure">
        Select the one that fits. Tell us what you hold and a member of the team will respond directly.
      </p>
      <div className="grid md:grid-cols-3 gap-px mt-8" style={{ background: "#24272B" }}>
        {VECTORS.map((v) => (
          <button
            key={v.key}
            onClick={() => setActive(v)}
            className="p-8 vector-card text-left w-full cursor-pointer"
            data-testid={v.testid}>
            <span className="fig t-small text-tint">{v.n} //</span>
            <h2 className="t-h2 text-bone mt-3">{v.title}</h2>
            <p className="t-small text-muted-s mt-4">{v.body}</p>
            <span className="t-label mt-6 inline-block text-tint">Send us your deal &rarr;</span>
          </button>
        ))}
      </div>
      <DealInquiryModal
        open={!!active}
        onOpenChange={(o) => { if (!o) setActive(null); }}
        party={active?.key || ""}
        partyLabel={active?.title || ""} />
    </section>
  );
}
